import moment from "moment";
import { Row, Col } from "antd";
import { FaAngleDown } from "react-icons/fa";

const FlightSummaryCollapseTbo = ({ flightDetails, collapseCard, setCollapseCard, setAddonsCompHide }) => {
    const getFlightInfo = (flight) => {
        if (!flight) return {};

        const departureDate = moment(flight?.departureTime).format("dddd, MMM D");
        const duration = moment.duration(flight?.duration, "minutes");
        const formattedDuration = `${duration.hours()}h ${duration.minutes()}m`;
        const stopsText = flight?.stops === 0 ? "Non Stop" : `${flight?.stops} Stop`;
        const airline = flight?.airline || "Unknown Airline";

        return {
            departureDate,
            formattedDuration,
            stopsText,
            airline,
            originCity: flight?.originCity,
            destinationCity: flight?.destinationCity
        };
    };

    const departureFlight = getFlightInfo(flightDetails?.flightDetails?.flights?.[0]);
    const returnFlight = getFlightInfo(flightDetails?.flightDetails?.returnFlight?.[0]);

    return (
        <div className="card flights-accordion">
            <div className="card-header">

                <Row className="mb-0">
                    <Col xs={24}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 className='fw-bold mb-2'>Flights Summary  </h3>
                            {/* {!collapseCard && (
                                <FaAngleDown
                                    onClick={() => { setCollapseCard(true); setAddonsCompHide(true) }}
                                />
                            )} */}
                        </div>
                        {departureFlight.originCity && (
                            <div className="text-muted mb-2">
                                <span className="fw-bold">{departureFlight.originCity}</span> →{" "}
                                <span className="fw-bold">{departureFlight.destinationCity}</span> ·{" "}
                                {departureFlight.departureDate} · {departureFlight.stopsText} · {departureFlight.formattedDuration} · {departureFlight.airline}
                            </div>
                        )}

                        {returnFlight.originCity && (
                            <div className="text-muted mb-2">
                                <span className="fw-bold">{returnFlight.originCity}</span> →{" "}
                                <span className="fw-bold">{returnFlight.destinationCity}</span> ·{" "}
                                {returnFlight.departureDate} · {returnFlight.stopsText} · {returnFlight.formattedDuration} · {returnFlight.airline}
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default FlightSummaryCollapseTbo;
